import React from "react"
import { Form, Button, Image, Row, Col } from "react-bootstrap"
import QuillTextEditor from "../../../../components/QuillTextEditor"

const EssentialInformationForm = ({
  fields,
  onInputChange,
  upload,
  showAlert,
  isUploading,
  validationErrors,
  setValidationErrors,
  section = "essentialInformation"
}) => {
  const handleInputChange = (key, value) => {
    onInputChange(section, key, value)
    if (validationErrors[`${section}.${key}`]) {
      setValidationErrors((prev) => ({
        ...prev,
        [`${section}.${key}`]: undefined,
      }))
    }
  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          Heading {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={`Title ${fields.isVisible ? "*" : ""}`}
          value={fields.title || ""}
          onChange={(e) => handleInputChange("title", e.target.value)}
          isInvalid={!!validationErrors[`${section}.title`]}
        />
        {validationErrors[`${section}.title`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.title`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      {/* Info Section */}
      <Form.Group className="mb-3">
        <Form.Label>Information Content</Form.Label>
        <QuillTextEditor
          value={fields.info || ""}
          onChange={(value) => handleInputChange("info", value)}
          placeholder="Enter detailed information content..."
        />
      </Form.Group>

      {/* Address Section */}
      <Form.Group className="mb-3">
        <Form.Label>Address</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          placeholder="Enter address"
          value={fields.address || ""}
          onChange={(e) => handleInputChange("address", e.target.value)}
        />
      </Form.Group>

      {/* Coordinates Section */}
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Latitude</Form.Label>
            <Form.Control
              type="number"
              step="any"
              placeholder="Enter latitude"
              value={fields.lat || ""}
              onChange={(e) => handleInputChange("lat", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Longitude</Form.Label>
            <Form.Control
              type="number"
              step="any"
              placeholder="Enter longitude"
              value={fields.lng || ""}
              onChange={(e) => handleInputChange("lng", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}

export default EssentialInformationForm
